"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = Tip;
const jsx_runtime_1 = require("react/jsx-runtime");
const material_1 = require("@mui/material");
const merge_1 = require("merge");
const index_style_1 = require("./index.style");
function Tip({ children, selected, onClick, blackThemeStyle, type, sx, startIcon, id }) {
    const theme = (0, material_1.useTheme)();
    const { tipContainer, tipLabel, startIconStyle, endIconStyle } = (0, index_style_1.default)(selected, blackThemeStyle, type);
    return ((0, jsx_runtime_1.jsxs)(material_1.Box, { sx: (0, merge_1.merge)(true, sx, tipContainer), onClick: onClick, id: id, children: [startIcon && theme.direction === 'ltr' && (0, jsx_runtime_1.jsx)(material_1.Box, { sx: startIconStyle, children: startIcon }), (0, jsx_runtime_1.jsx)(material_1.Box, { sx: tipLabel, children: children }), startIcon && theme.direction === 'rtl' && (0, jsx_runtime_1.jsx)(material_1.Box, { sx: endIconStyle, children: startIcon })] }));
}
